import type React from 'react';

import type { FileAttachment } from 'api/types';
import { styled } from '@mui/material';
import { Attachment } from 'components/LiveChatInput/Attachment';

interface AttachmentsMessageProps {
  attachments: FileAttachment[];
}

// Currently used by one window live chat only
export const AttachmentsMessage: React.FC<AttachmentsMessageProps> = ({
  attachments,
}) => {
  if (!attachments.length) {
    return null;
  }

  return (
    <AttachmentsContainer>
      {attachments.map(attachment => (
        <Attachment attachment={attachment} hasContainer key={attachment.url} />
      ))}
    </AttachmentsContainer>
  );
};

const AttachmentsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;
